import createIcon from '../../createIcon';

/**
 * @component @name Power
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuMDEgN0wxNiAzSDE0VjdIMTBWM0g4VjdINy45OUM3IDYuOTkgNiA3Ljk5IDYgOC45OVYxNC40OEw5LjUgMThWMjFIMTQuNVYxOEwxOCAxNC40OVY4Ljk5QzE4IDcuOTkgMTcgNi45OSAxNi4wMSA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Power = createIcon('Power', [
  [
    'path',
    {
      d: 'M16.01 7L16 3H14V7H10V3H8V7H7.99C7 6.99 6 7.99 6 8.99V14.48L9.5 18V21H14.5V18L18 14.49V8.99C18 7.99 17 6.99 16.01 7Z',
      key: 'mfdwrw',
    },
  ],
]);

export default Power;
